import React from 'react';
import { connect } from 'react-redux';
import ServerView from './ServerView';
import CloudDeviceView from './CloudDeviceView';
import { getProductConfig } from '../backend/productConfig';

/**
 * JumpControl — product-scoped "jump" control. The LOCAL NVR viewer jumps between
 * NVR servers (ServerView). The CLOUD viewer has NO jump (David): it surfaces all
 * devices' cameras at once and saved VIEWS are the sole navigation, so the profile's
 * `hasJump` is false there and this renders nothing. `jumpKind` picks the control when
 * a jump does exist. LiveView renders <JumpControl /> at the same call sites regardless
 * of product — no `if (cloud)` in the view. Props (e.g. onJumpStarted) pass through.
 */
const JumpControl = ({ productMode, ...rest }) => {
  const cfg = getProductConfig({ productMode });
  if (!cfg.hasJump) return null;   // CLOUD: views are the sole navigation
  return cfg.jumpKind === 'device' ? <CloudDeviceView {...rest} /> : <ServerView {...rest} />;
};

const mapStateToProps = (state) => ({ productMode: state.productMode });

export default connect(mapStateToProps)(JumpControl);
